import { render } from "./ItemsAdministration.vue?vue&type=template&id=1b0c815c&scoped=true&ts=true"
import script from "./ItemsAdministration.vue?vue&type=script&lang=ts"
export * from "./ItemsAdministration.vue?vue&type=script&lang=ts"

import "./ItemsAdministration.vue?vue&type=style&index=0&id=1b0c815c&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0c815c"]])

export default __exports__